// extracted by mini-css-extract-plugin
export default {"container":"Municipality_container__aQV8C","label":"Municipality_label__ZqZd0","active":"Municipality_active__fkifL"};